import _ from 'lodash';

import {
  GAME_ID,
  REDUX_ACTIONS,
  NARRATION_TYPES,
  NARRATION_HINT_TYPES,
  NARRATION_TIP_TYPES,
} from '../../data/planTorresConstants';

const initialState = {
  narrationId: null,
  narrationType: '',
  narrations: [],
};

const getStandardHintNarrations = ({ hintType, phonemes }) => {
  const [phoneme1, phoneme2] = phonemes;

  switch (hintType) {
    // single vo
    case NARRATION_HINT_TYPES.LOOK_BEGINNING:
      return [{
        section: 'vo',
        key: 'lookBeginning',
      }];
    case NARRATION_HINT_TYPES.LOOK_MONOSYLLABLE:
      return [{
        section: 'vo',
        key: 'lookMonosyllable',
      }];
    case NARRATION_HINT_TYPES.LOOK_MIDDLE:
      return [{
        section: 'vo',
        key: 'lookMiddle',
      }];
    case NARRATION_HINT_TYPES.LOOK_MIDDLES:
      return [{
        section: 'vo',
        key: 'lookMiddles',
      }];
    case NARRATION_HINT_TYPES.LOOK_ENDING:
      return [{
        section: 'vo',
        key: 'lookEnding',
      }];
    case NARRATION_HINT_TYPES.REMOVE_BEGINNING:
      return [{
        section: 'vo',
        key: 'removeBeginning',
      }];
    case NARRATION_HINT_TYPES.REMOVE_ENDING:
      return [{
        section: 'vo',
        key: 'removeEnding',
      }];
    // vo/phoneme
    case NARRATION_HINT_TYPES.CHANGE_BEGINNING:
      return [{
        section: 'vo',
        key: 'changeBeginning',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.CHANGE_MIDDLE:
      return [{
        section: 'vo',
        key: 'changeMiddle',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.CHANGE_MIDDLES:
      return [{
        section: 'vo',
        key: 'changeMiddle',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.CHANGE_ENDING:
      return [{
        section: 'vo',
        key: 'changeEnding',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    // vo/phoneme/sound
    case NARRATION_HINT_TYPES.CHANGE_SOUND:
      return [{
        section: 'vo',
        key: 'changeThe',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.CHANGE_ADD:
      return [{
        section: 'vo',
        key: 'changeAdd',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.REMOVE_SOUND:
      return [{
        section: 'vo',
        key: 'removeThe',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    case NARRATION_HINT_TYPES.ADD_SOUND:
      return [{
        section: 'vo',
        key: 'addThe',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }];
    // vo/phoneme/vo
    case NARRATION_HINT_TYPES.SOUND_BEGINNING:
      return [{
        section: 'vo',
        key: 'addThe',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }, {
        section: 'vo',
        key: 'soundBeginning',
      }];
    // vo/phoneme/vo/vo/phoneme
    case NARRATION_HINT_TYPES.CHANGE_SOUND_TO:
      return [{
        section: 'vo',
        key: 'changeThe',
      }, {
        section: 'phonemes',
        key: phoneme1,
      }, {
        section: 'vo',
        key: 'to',
      }, {
        section: 'phonemes',
        key: phoneme2,
      }];
    default:
      return [];
  }
};

const getStandardTipNarrations = ({ tipType, referenceWord, questionId }) => {
  switch (tipType) {
    case NARRATION_TIP_TYPES.ONBOARDING_TIP_DRAG_THE_SYLLABLE:
      return [{
        section: 'vo',
        key: 'onboardingDrag',
      }, {
        section: 'words',
        key: questionId,
      }];
    case NARRATION_TIP_TYPES.STANDARD_TIP_CHANGE:
      return [{
        section: 'vo',
        key: 'change',
      }, {
        section: 'words',
        key: referenceWord,
      }, {
        section: 'vo',
        key: 'to',
      }, {
        section: 'words',
        key: questionId,
      }];
    case NARRATION_TIP_TYPES.ONBOARDING_TIP_REMOVE:
      return [{
        section: 'vo',
        key: 'onboardingRemove',
      }, {
        section: 'vo',
        key: 'change',
      }, {
        section: 'words',
        key: referenceWord,
      }, {
        section: 'vo',
        key: 'to',
      }, {
        section: 'words',
        key: questionId,
      }];
    default:
      return [];
  }
};

const planTorresNarrationReducer = (state = initialState, action) => {
  if (action.gameId !== GAME_ID) {
    return state;
  }

  switch (action.type) {
    case REDUX_ACTIONS.INIT_STANDARD_TIP_NARRATION: {
      return {
        ...initialState,
        narrationId: _.uniqueId('narration_'),
        narrationType: NARRATION_TYPES.STANDARD_TIP,
        narrations: getStandardTipNarrations(action.payload),
      };
    }
    case REDUX_ACTIONS.INIT_STANDARD_HINT_NARRATION: {
      return {
        ...initialState,
        narrationId: _.uniqueId('narration_'),
        narrationType: NARRATION_TYPES.STANDARD_HINT,
        narrations: getStandardHintNarrations(action.payload),
      };
    }
    default:
      return state;
  }
};

export default planTorresNarrationReducer;
